import React from "react"
import { Form } from "react-router-dom"
import { Api } from "../lib/api"

import { Input, Button, VStack, HStack, Text } from "@chakra-ui/react"

import "../components/Login.css"
import GradientBox from "./GradientBox"
import { addAlert, AlertType } from "@/lib/alerts"

export default function ForgotPassword() {
  const api = new Api()

  const handlePasswordReset = async (event) => {
    event.preventDefault()
    const email = event.target.email.value
    console.log("Resetting password for", email)
    await api.accountsSendPasswordResetLink(email)
    addAlert(
      AlertType.SUCCESS,
      "Password Reset",
      "Password reset link sent to " + email,
      5,
    )
  }

  return (
    <GradientBox>
      <VStack
        minWidth="100%"
        justifyContent="space-between"
        alignItems="left"
        mt="3em"
      >
        <Text fontSize="1.75em" color="white">
          Forgot your Blind Insight password?
        </Text>
        <Text fontSize="1.25em" color="white" mb="2em">
          Enter your email and we will send you a link.
        </Text>
        <Form onSubmit={handlePasswordReset}>
          <Text variant="subtext">Email</Text>
          <Input
            mt="1em"
            variant="account"
            id="email"
            name="email"
            type="email"
            isRequired
          />
          <Text variant="subtext"> </Text>
          <HStack justifyContent="flex-end" mt="1em">
            <Button variant="account" type="submit">
              Send Link
            </Button>
          </HStack>
        </Form>
      </VStack>
      <span />
      <span />
    </GradientBox>
  )
}
